<template>
  <!-- 弹窗左部分 -->
  <div class="popupLeft">
    <h2>{{ popupH2 }}</h2>
    <dl class="checkBox" id="popup_zy">
      <p>
      <img src="/static/Index/popup-zx.png" alt="">
      </p>
      <!-- <p>

        <label>西餐料理</label>
      </p>
      <p>

        <label>咖啡饮品</label>
      </p>
      <p>

        <label>精品调酒</label>
      </p> -->
    </dl>
    <div class="popupInput">
      <input type="text" id="popup_xm" maxlength="11" placeholder="姓名：" name="b_xm" class="name" />
      <input
        id="popup_tel"
        class="tel"
        type="tel"
        maxlength="11"
        placeholder="电话:"
        name="b_tel"
        oninput="value=value.replace(/[^\d]/g,'')"
      />
    </div>
    <p class="popupP">
      现在预约即可享
      <b>千元助学金</b>
    </p>
    <span>
      <a class="red popupHref" :href="popupHrefA">{{ popupA }}</a>
    </span>
  </div>
</template>

<script>
export default {
  name: "popupLeft",
  data() {
    return {
      popupH2: "来欧米奇，学习热门技能",
      popupHrefA: "javascript:void(0);",
      popupHrefB: "javascript:void(0);",
      popupA: "提交获取名额",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
/* 弹窗左部分 */
.popupLeft {
  margin: 0 20px;
  h2 {
    line-height: 60px;
    padding-top: 20px;
  }
  .checkBox {
    display: flex;
    p {
      font-size: 20px;
      input {
        width: 15px;
        height: 15px;
      }
    }
  }
  .popupInput {
    input {
      width: 200px;
      height: 40px;
        text-indent: 10px;
      padding: 0;
      font-size: 18px;
      margin-bottom: 20px;
    }
  }
  .popupP {
    font-size: 18;
    b {
      color: #f00;
    }
  }
  span {
    margin-top: 20px;
    display: flex;
    a {
      display: block;
      width: 150px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 18px;
    }
  }
  .red {
    background: #f00;
  }
  .yellow {
    background: #f69047;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popup/popupLeft.vue